module.exports = __webpack_public_path__ + "img/check-mark-white.61d54e52.png";